import axios from "axios";
import { SERVER_URL } from "../constants/server";

export const submitInterview = (data) =>
  axios.post(SERVER_URL + "/api/interviews/", data, {
    withCredentials: true,
  });

export const getAllInterviews = (token, limit = 50, offset = 0) =>
  axios.post(SERVER_URL + "/api/interviews/all", {
    token,
    limit,
    offset,
    withCredentials: true,
  });

export const deleteInterview = (id, token) =>
  axios.post(SERVER_URL + "/api/interviews/delete", {
    id,
    token,
    withCredentials: true,
  });

export const markInterviewNoShow = (id, token) =>
  axios.post(SERVER_URL + "/api/interviews/no-show", {
    id,
    token,
    withCredentials: true,
  });

export const cancelInterview = (id, token) =>
  axios.post(SERVER_URL + "/api/interviews/cancel", {
    id,
    token,
    withCredentials: true,
  });

// date is YYYY-MM-DD and time is HH:MM, as produced by the date and time inputs
export const rescheduleInterview = (id, interviewDate, interviewTime, token) =>
  axios.post(SERVER_URL + "/api/interviews/reschedule", {
    id,
    token,
    interview_date: interviewDate,
    interview_time: interviewTime,
    withCredentials: true,
  });
